module.exports = __webpack_public_path__ + "img/freeModeOn.eacdfc25.svg";